import apiNtzTemplate from '@/api/ntz-template'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  Training: null,
}

export const mutationTypes = {
  updateNtzTemplateStart: '[update ntz template] Update ntz template start',
  updateNtzTemplateSuccess: '[update ntz template] Update ntz template success',
  updateNtzTemplateFailure: '[update ntz template] Update ntz template failure',

  getNtzTemplateStart: '[update ntz template] Get ntz template start',
  getNtzTemplateSuccess: '[update ntz template] Get ntz template success',
  getNtzTemplateFailure: '[update ntz template] Get ntz template failure',
}

export const actionTypes = {
  updateNtzTemplate: '[update ntz template] Update ntz template',
  getNtzTemplate: '[update ntz template] Get ntz template',
}

const mutations = {
  [mutationTypes.updateNtzTemplateStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateNtzTemplateSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateNtzTemplateFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getNtzTemplateStart](state) {
    state.isLoading = true
    state.Ntz = null
  },

  [mutationTypes.getNtzTemplateSuccess](state, payload) {
    state.Ntz = payload
    state.isLoading = false
  },

  [mutationTypes.getNtzTemplateFailure](state, payload) {
    state.error = payload
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.updateNtzTemplate](context, {id, template}) {
    context.commit(mutationTypes.updateNtzTemplateStart)
    return new Promise((resolve) => {
      apiNtzTemplate
        .updateNtzTemplate(id, template)
        .then((response) => {
          context.commit(mutationTypes.updateNtzTemplateSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateNtzTemplateFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getNtzTemplate](context, {id}) {
    context.commit(mutationTypes.getNtzTemplateStart)
    return new Promise((resolve) => {
      apiNtzTemplate
        .getNtzTemplate(id)
        .then((response) => {
          context.commit(mutationTypes.getNtzTemplateSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getNtzTemplateFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
